import { LAYOUT_RESIZE } from '../actions';

import { LAYOUT_RESIZED, LAYOUT_CHANGED_POINT, POPUP_OPENED, POPUP_CLOSED, ROUTE_CHANGED } from '../mutation-types';

import findKey from 'lodash/findKey';
import inRange from 'lodash/inRange';
import isMatch from 'lodash/isMatch';
import includes from 'lodash/includes';

class Point {
   /**
    * Creates an instance of Point.
    *
    * @param {string} name name of point
    * @param {number} from min-width
    * @param {number} to   max-width
    */
   constructor(name, from, to) {
      this.name = name;
      this.from = from;
      this.to = to;
      Object.freeze(this);
   }
}

const SCREEN_XS_MIN = 0;
const SCREEN_SM_MIN = 640;
const SCREEN_MD_MIN = 992;
const SCREEN_LG_MIN = 1200;
const SCREEN_LG_MAX = Number.MAX_VALUE;

const POINTS = Object.freeze({
   XS : new Point('xs', SCREEN_XS_MIN, SCREEN_SM_MIN),
   SM : new Point('sm', SCREEN_SM_MIN, SCREEN_MD_MIN),
   MD : new Point('md', SCREEN_MD_MIN, SCREEN_LG_MIN),
   LG : new Point('lg', SCREEN_LG_MIN, SCREEN_LG_MAX)
});

const state = {
   popups: 0,
   path: '',
   historyStack: [],
   layout: {
      w: null,
      h: null
   },
   point: {
      width: {
         name: '',
         from: 0,
         to: 0
      },
      height: {
         name: '',
         from: 0,
         to: 0
      }
   }
};

const getters = {
   isMobile : state => includes([POINTS.XS, POINTS.SM], state.point.width),
   isLarge  : state => state.point.width === POINTS.LG,
   isExtraSmall : state => state.point.width === POINTS.XS,
   getLayoutPoint  : state => state.point.width,
   getCurrentWidth : state => state.layout.w,
   hasPopups       : state => !!state.popups,
   getRoutePath    : state => state.path
};

const actions = {
   [LAYOUT_RESIZE]({commit, state}, {w, h}) {
      commit(LAYOUT_RESIZED, {w, h});

      const widthKey = findKey(POINTS, (p) => inRange(w, p.from, p.to));
      const heightKey = findKey(POINTS, (p) => inRange(h, p.from, p.to));

      const width = POINTS[widthKey];
      const height = POINTS[heightKey];

      if (!isMatch(state.point, { width, height })) {
         commit(LAYOUT_CHANGED_POINT, { width, height });
      }
   }
};

const mutations = {
   [LAYOUT_RESIZED](state, layout) {
      state.layout = layout;
   },
   [LAYOUT_CHANGED_POINT](state, { width, height }) {
      state.point.width  = width;
      state.point.height = height;
   },
   [POPUP_OPENED](state) {
      state.popups += 1;
   },
   [POPUP_CLOSED](state) {
      state.popups -= 1;
   },
   [ROUTE_CHANGED](state, path) {
      state.path = path;
      state.historyStack.push(path);
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};
